export { default } from './ClientPswdMustChangeDialog';
export type { ClientPswdMustChangeDialogProps } from './ClientPswdMustChangeDialog';
